module.exports = __webpack_public_path__ + "img/play.7de1b107.svg";